import { createAction } from '@ngrx/store';

export const closeGallery = createAction('[MediaGallery] Close Gallery');
